import { YesNoNull } from 'types/types';

type NullableBoolean = boolean | null;

export const yesNoToBool = (yesNo: YesNoNull): NullableBoolean =>
    yesNo === 'YES' ? true : yesNo === 'NO' ? false : null;

export const boolToYesNo = (bool: NullableBoolean): YesNoNull => (bool === true ? 'YES' : bool === false ? 'NO' : null);
